<template>
  <select-product :config="config"
                  @input="handleInput"
                  :value="selected"/>
</template>

<script>
/* globals route axios */

import SelectProduct from '../products/ProductSelect.vue';
import filter from '../../mixins/filter';

export default {
  mixins: [filter],

  components: { SelectProduct },

  computed: {
    config() {
      return {
        'allow-empty': true,
        multiple: this.multiple,
        closeOnSelect: false,
        clearOnSelect: false,
      };
    },
  },

  data() {
    return {
      selected: [],
    };
  },

  methods: {
    setSelected() {
      this.selected = [];
      const params = this.getParam();

      if (!params) {
        return;
      }

      axios
        .get(`${route('api.products.index')}?products=${params}`)
        .then(({ data }) => {
          this.selected = data.data;
        })
        .catch(() => {
          this.selected = [];
        });
    },
  },
};
</script>
